import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Event, Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { LoaderService } from './services/loader/LoaderService';

declare var $: any;

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: `<router-outlet>
      <div *ngIf="showLoader" class="loading">
        <div class="loading-panel">
          <span class="loading-spinner"></span>
          <span class="loading-label">Loading...</span>
        </div>
      </div>
    </router-outlet>`,
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

    showLoader: boolean = false;
    showChat: boolean = true;
    private modalBlurBound: boolean = false;
    private modalBackdropObserver: MutationObserver;

    constructor(private router: Router, private loaderService: LoaderService, private cdRef: ChangeDetectorRef) {
        if (window.location.host.includes('localhost')) {
            this.showChat = false;
        }
    }

    ngAfterViewInit(): void {
        loadScript();
    }

    ngOnInit() {

        // this.translateService.use('en-US');

        this.initGlobalModalBackdrop();

        this.router.events.subscribe(
            (evt: Event) => {

                if (evt instanceof NavigationStart || evt instanceof RouteConfigLoadStart) {
                    this.loaderService.show();
                }

                if (evt instanceof RouteConfigLoadEnd || evt instanceof NavigationCancel || evt instanceof NavigationError || evt instanceof NavigationEnd) {
                    this.loaderService.hide();;
                }

                if (!(evt instanceof NavigationEnd)) {
                    window.scrollTo(0, 0);
                    return;
                }

            });

        this.loaderService.status.subscribe((val: boolean) => {
            if (val != this.showLoader) {
                this.showLoader = val;
                this.cdRef.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        if (typeof $ !== 'undefined' && this.modalBlurBound) {
            $(document).off('show.bs.modal.appBlur hidden.bs.modal.appBlur', '.modal');
        }

        if (this.modalBackdropObserver) {
            this.modalBackdropObserver.disconnect();
        }
    }

    private initGlobalModalBackdrop() {
        if (typeof $ === 'undefined' || this.modalBlurBound) {
            return;
        }

        this.modalBlurBound = true;

        $(document).on('show.bs.modal.appBlur', '.modal', () => {
            this.applyGlobalModalBackdrop();
        });

        $(document).on('hidden.bs.modal.appBlur', '.modal', () => {
            if ($('.modal.show').length === 0) {
                this.clearGlobalModalBackdrop();
            }
        });

        if (typeof MutationObserver !== 'undefined') {
            this.modalBackdropObserver = new MutationObserver(() => {
                if (document.body.classList.contains('modal-open')) {
                    this.applyGlobalModalBackdrop();
                } else if (!document.querySelector('.modal-backdrop')) {
                    this.clearGlobalModalBackdrop();
                }
            });

            this.modalBackdropObserver.observe(document.body, {
                childList: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    private applyGlobalModalBackdrop() {
        const setStyles = () => {
            const $backdrop = $('.modal-backdrop');
            if (!$backdrop.length) {
                window.setTimeout(setStyles, 0);
                return;
            }

            $backdrop.addClass('app-modal-backdrop-blur');
        };

        setStyles();
    }

    private clearGlobalModalBackdrop() {
        $('.modal-backdrop').removeClass('app-modal-backdrop-blur');
    }
}

function loadScript() {
    if (!window.location.host.includes('localhost')) {
        let node = document.createElement('script');
        node.src = '../../../assets/js/pure-chat.js';
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
    }
}